import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import { TrackedTextField } from "src/theme/StyledFields";
import { useState } from "react";

/**
 * TextField for password input with a visibility toggle button.
 * Forwards all TextField props; type and InputProps.endAdornment are controlled internally.
 */
export default function PasswordField({ ...props }) {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TrackedTextField
      {...props}
      type={showPassword ? "text" : "password"}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={showPassword ? "Hide password" : "Show password"}
              onClick={handleToggleVisibility}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
              size="small"
              data-attr={props["data-attr"] ? `${props["data-attr"]}_visibility-toggle` : undefined}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
